import { z } from "zod";
import { Confidence, DateISO, DueType, Effort, EntitySource, Priority, PushOption, StepStatus, TaskStatus, } from "../enums.js";
import { UserSummary } from "./user.js";
export const Step = z.object({
    id: z.string().uuid(),
    project_id: z.string().uuid(),
    position: z.number().int(),
    title: z.string(),
    description: z.string(),
    status: StepStatus,
    due_date: DateISO.nullable(),
    due_type: DueType.nullable(),
    original_due_date: DateISO.nullable(),
    slip_count: z.number().int(),
    is_milestone: z.boolean(),
    completed_at: z.string().nullable(),
    source: EntitySource,
    created_at: z.string(),
    updated_at: z.string(),
    // computed
    task_count: z.number().int(),
    done_task_count: z.number().int(),
});
export const CreateStepInput = z.object({
    title: z.string().min(1).max(200),
    description: z.string().max(10000).default(""),
    due_date: DateISO.nullable().optional(),
    due_type: DueType.nullable().optional(),
    is_milestone: z.boolean().default(true),
    status: StepStatus.default("pending"),
    /** Insert position (0-based). Omitted = append. */
    position: z.number().int().min(0).optional(),
});
export const UpdateStepInput = z.object({
    title: z.string().min(1).max(200).optional(),
    description: z.string().max(10000).optional(),
    due_date: DateISO.nullable().optional(),
    due_type: DueType.nullable().optional(),
    is_milestone: z.boolean().optional(),
    status: StepStatus.optional(),
    position: z.number().int().min(0).optional(),
});
export const ReorderStepsInput = z.object({ ordered_ids: z.array(z.string().uuid()).min(1) });
export const Task = z.object({
    id: z.string().uuid(),
    project_id: z.string().uuid(),
    step_id: z.string().uuid().nullable(),
    title: z.string(),
    details: z.string(),
    assignee: UserSummary.nullable(),
    status: TaskStatus,
    blocked_reason: z.string().nullable(),
    priority: Priority,
    effort: Effort.nullable(),
    due_date: DateISO.nullable(),
    due_type: DueType.nullable(),
    snoozed_until: DateISO.nullable(),
    agent_eligible: z.boolean(),
    agent_instructions: z.string().nullable(),
    source: EntitySource,
    needs_review: z.boolean(),
    ai_confidence: Confidence.nullable(),
    position: z.number().int(),
    completed_at: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});
export const CreateTaskInput = z.object({
    project_id: z.string().uuid(),
    step_id: z.string().uuid().nullable().optional(),
    title: z.string().min(1).max(200),
    details: z.string().max(20000).default(""),
    assignee_id: z.string().uuid().nullable().optional(),
    status: TaskStatus.default("todo"),
    priority: Priority.default("medium"),
    effort: Effort.nullable().optional(),
    due_date: DateISO.nullable().optional(),
    due_type: DueType.nullable().optional(),
    agent_eligible: z.boolean().default(false),
    agent_instructions: z.string().max(10000).nullable().optional(),
});
export const UpdateTaskInput = z.object({
    step_id: z.string().uuid().nullable().optional(),
    title: z.string().min(1).max(200).optional(),
    details: z.string().max(20000).optional(),
    assignee_id: z.string().uuid().nullable().optional(),
    status: TaskStatus.optional(),
    blocked_reason: z.string().max(1000).nullable().optional(),
    priority: Priority.optional(),
    effort: Effort.nullable().optional(),
    due_date: DateISO.nullable().optional(),
    due_type: DueType.nullable().optional(),
    snoozed_until: DateISO.nullable().optional(),
    agent_eligible: z.boolean().optional(),
    agent_instructions: z.string().max(10000).nullable().optional(),
    needs_review: z.boolean().optional(),
    position: z.number().int().min(0).optional(),
});
export const PushInput = z.object({ option: PushOption, reason: z.string().max(400).optional() });
export const TaskFilters = z.object({
    project_id: z.string().uuid().optional(),
    assignee_id: z.string().uuid().optional(),
    status: TaskStatus.optional(),
    needs_review: z.coerce.boolean().optional(),
});
//# sourceMappingURL=plan.js.map